import React from "react";
import Card from "../Card";
import Button from "../Button";

const features = [
  {
    title: "Match & Connect",
    description:
      "Connect with families who truly understand your journey. Our easy-to-use filters help you search by age, gender, interests, and unique needs—empowering you to build meaningful connections that matter.",
    iconBg: "bg-spectrum-blue text-surface-white",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
        <path d="M19 8v6M22 11h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Support",
    description:
      "Social Spectrum is not just a platform, it's a supportive community. We provide resources, guidelines, and a network of parents who understand the journey you're on.",
    iconBg: "bg-heart-teal text-surface-white",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Empowerment",
    description:
      "Our goal is to empower parents to actively contribute to their child's social development by facilitating connections that go beyond the virtual world.",
    iconBg: "bg-sunshine text-ink",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <polygon
          points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const Ourcommitment = () => {
  return (
    <section className="bg-surface-white py-16 md:py-24 text-left w-full" id="features">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <span className="inline-block bg-cloud-mist text-spectrum-blue text-xs font-bold tracking-wider px-3.5 py-1 rounded-brand mb-3 font-headline">
            OUR FEATURES
          </span>
          <h2 className="font-headline text-3xl md:text-4xl text-ink leading-tight mb-4">
            <span className="font-light">Empowering Caregivers,</span>
            <span className="font-extrabold text-spectrum-blue block sm:inline">
              {" "}
              One Connection at a Time.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-10">
          {features.map((feature) => (
            <Card key={feature.title} variant="mist" className="flex flex-col justify-between">
              <div>
                <div
                  className={`w-12 h-12 rounded-brand flex items-center justify-center mb-6 shadow-brand-sm ${feature.iconBg}`}
                >
                  {feature.icon}
                </div>
                <h3 className="font-headline font-bold text-xl text-ink mb-3">
                  {feature.title}
                </h3>
                <p className="font-body text-muted text-[15px] leading-relaxed max-w-[340px]">
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        <Button to="/ourapp" variant="primary" size="md">
          Know More →
        </Button>
      </div>
    </section>
  );
};

export default Ourcommitment;
